import { Grid } from "@mui/material";

import IntegrationBlock from "../IntegrationBlock";
import type { IIntegrationsList } from "../types";
interface IShowIntegrations {
    integrations: IIntegrationsList;
}

const ShowIntegrations = ({ integrations }: IShowIntegrations) => {
    return (
        <div className="integrations-wrapper">
            <Grid container spacing={2}>
                {integrations.map((integration, index) => (
                    <>
                        {!integration.disabled && (
                            <Grid item sm={6} xl={4} key={`${integration.name}-${index}`}>
                                <IntegrationBlock
                                    title={integration.title}
                                    name={integration.name}
                                    icon={integration.icon}
                                    subtitle={integration.subtitle}
                                    isConnected={integration.isConnected}
                                    onConnect={integration.onConnect}
                                    onDisconnect={integration.onDisconnect}
                                    onOpenDetails={integration.onOpenDetails}
                                    integrations={integration.integrations}
                                />
                            </Grid>
                        )}
                    </>
                ))}
            </Grid>
        </div>
    );
};

export default ShowIntegrations;
